// extracted by mini-css-extract-plugin
module.exports = {"title":"confirm-email-success_title__Wx53f","textWrap":"confirm-email-success_textWrap__ob9Iy","buttonWrap":"confirm-email-success_buttonWrap__2SUcX"};